import { IFsFileData, IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsAudio, FsFile, FsImage, FsImage360, FsImageTarget, FsModel3D, FsVideo, FsVideo360 } from "./files";

export class Filestore {
    private _files: {[id: string]: FsFile} = {}

    constructor() {

    }

    load(data: { [id: string]: IFsFileData }) {
        for (const id in data) {
            switch (data[id].type) {
                case IFsFileType.Image:
                    this._files[id] = new FsImage(id, data[id].name); break
                case IFsFileType.Video:
                    this._files[id] = new FsVideo(id, data[id].name); break
                case IFsFileType.Audio:
                    this._files[id] = new FsAudio(id, data[id].name); break
                case IFsFileType.Model3d:
                    this._files[id] = new FsModel3D(id, data[id].name); break
                case IFsFileType.Image360:
                    this._files[id] = new FsImage360(id, data[id].name); break
                case IFsFileType.Video360:
                    this._files[id] = new FsVideo360(id, data[id].name); break
                case IFsFileType.ImageTarget:
                    this._files[id] = new FsImageTarget(id, data[id].name); break
                default:
                    throw new Error(`Unknown file type: ${data[id].type}`)
            }
        }
    }

    // loadFiles() {
    //     const promises: Promise<FsFile>[] = []
    //     for (const id in this._files) {
    //         promises.push(this._files[id].load())
    //     }
    //     return Promise.all(promises)
    // }

    get<T extends FsFile>(id?: string) {
        if (typeof id === 'undefined') throw new Error('File ID is required')
        return this._files[id] as T
    }

    getAll() {
        return this._files;
    }

}

// Singletone
export const filestore = new Filestore()
